import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { MessageModule } from 'primeng/message'

@Component({
    selector: 'fm-suspended-banner',
    standalone: true,
    imports: [FontAwesomeModule, MessageModule],
    templateUrl: './suspended-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuspendedBannerComponent {
    @Output() openSuspension = new EventEmitter<void>()

    readonly faInfoCircle = faInfoCircle
}
